var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2937_1979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3236 0.0742188H1.51848C1.24733 0.0742188 0.987281 0.181935 0.795545 0.37367C0.60381 0.565406 0.496094 0.825454 0.496094 1.09661V12.9017C0.496094 13.1729 0.60381 13.4329 0.795545 13.6246C0.987281 13.8164 1.24733 13.9241 1.51848 13.9241H13.3236C13.5947 13.9241 13.8548 13.8164 14.0465 13.6246C14.2383 13.4329 14.346 13.1729 14.346 12.9017V1.09661C14.346 0.825454 14.2383 0.565406 14.0465 0.37367C13.8548 0.181935 13.5947 0.0742188 13.3236 0.0742188ZM4.62413 11.8726H2.54184V5.25831H4.62413V11.8726ZM3.58154 4.34171C3.34534 4.34038 3.11483 4.26911 2.91909 4.1369C2.72336 4.00469 2.57117 3.81745 2.48175 3.59883C2.39232 3.38021 2.36966 3.14 2.41663 2.90851C2.46359 2.67702 2.57808 2.46464 2.74563 2.29815C2.91319 2.13167 3.12631 2.01855 3.35809 1.97307C3.58988 1.92759 3.82994 1.9518 4.04798 2.04262C4.26603 2.13345 4.45228 2.28683 4.58323 2.48341C4.71418 2.67999 4.78397 2.91096 4.78379 3.14716C4.78601 3.3053 4.75638 3.46227 4.69665 3.60871C4.63693 3.75515 4.54833 3.88807 4.43614 3.99954C4.32395 4.11102 4.19046 4.19876 4.04364 4.25755C3.89682 4.31633 3.73966 4.34496 3.58154 4.34171ZM12.2993 11.8784H10.2179V8.26488C10.2179 7.19921 9.76493 6.87028 9.18016 6.87028C8.56269 6.87028 7.95675 7.33579 7.95675 8.29181V11.8784H5.87446V5.26311H7.87693V6.17971H7.90386C8.10487 5.77287 8.80891 5.07749 9.88323 5.07749C11.0451 5.07749 12.3002 5.7671 12.3002 7.78687L12.2993 11.8784Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2937_1979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8499,
    height: 13.8499,
    fill: "white",
    transform: "translate(0.496094 0.0742188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.f77e303e1d77a4e4549c7b6e9bfdc547.svg";
export { ForwardRef as ReactComponent };